/* import __COLOCATED_TEMPLATE__ from './legend-overlay.hbs'; */
import Component from '@ember/component';

export default class LegendOverlay extends Component {
    tagName = '';

    infoBodyArgs = {};
}
